import React from 'react';

type PulseHistoryIconProps = {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
};

const PulseHistoryIcon: React.FC<PulseHistoryIconProps> = ({
  size = 24,
  color = '#059669',
  strokeWidth = 1.5,
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Outer Refresh Arrow */}
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />

      {/* Internal Chart/Trend Line */}
      <path d="M8 15l2-2.5 2.5 2 3.5-6 2 2.5" />
    </svg>
  );
};

export default PulseHistoryIcon;
